import { render, staticRenderFns } from "./inquiryBillObject.vue?vue&type=template&id=70578e8d&scoped=true&"
import script from "./inquiryBillObject.vue?vue&type=script&lang=js&"
export * from "./inquiryBillObject.vue?vue&type=script&lang=js&"
import style0 from "./inquiryBillObject.vue?vue&type=style&index=0&id=70578e8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70578e8d",
  null
  
)

component.options.__file = "inquiryBillObject.vue"
export default component.exports